const PersonaliaItem = (props) => {
  const tussenvoegsel =
    props.tussenvoegsel.trim().length !== 0 ? (
      <>
        <span>{props.tussenvoegsel}</span>
        <br />
      </>
    ) : (
      ""
    );

    function ConvertDateStringToDate(strDate, type){
      function addZero(i) {
        if (i < 10) {
          i = "0" + i;
        }
        return i;
      }

      const d = new Date(strDate);
      const dag = d.toLocaleString("nl-NL", { day: "2-digit" });
      const maand = d.toLocaleString("nl-NL", { month: "2-digit" });
      const jaar = d.getFullYear();
      const datum = dag + "-" + maand + "-" + jaar;

      const uur = addZero(d.getHours());
      const minuut = addZero(d.getMinutes());
      const seconde = addZero(d.getSeconds());
      const tijd = uur + ":" + minuut + ":" + seconde;
      
      switch (type) {
        case "date":
          return datum;
          //break;
        case "time":
          return tijd;
          //break;
        default:
          return datum + " " + tijd;
      }
    }

  return (
    <li key={props.id}>
      <div>
        <span>{props.id}</span>
        <br />
        <span>{props.geslacht}</span>
        <br />
        <span>{props.voorletters}</span>
        <br />
        <span>{props.voornaam}</span>
        <br />
        {tussenvoegsel}
        <span>{props.achternaam}</span>
        <br />
        <span>{ConvertDateStringToDate(props.geboortedatum, "date")}</span>
        <br />
        <span>{props.geboorteplaats}</span>
        <br />
        <span>{props.straat}</span>
        <br />
        <span>{props.huisnummer}</span>
        <br />
        <span>{props.postcode}</span>
        <br />
        <span>{props.woonplaats}</span>
        <br />
        <span>{props.land}</span>
        <br />
        <span>{props.email}</span>
        <br />
        <span>{props.telefoon}</span>
        <br />
        <span>{props.mobiel}</span>
        <br />
        <span>{props.website}</span>
        <br />
        <span>{props.overig}</span>
        <br />
        {/*<span>{props.ip}</span>
        <br />
        <span>{props.hostname}</span>
        <br />*/}
        <span>{ConvertDateStringToDate(props.wijzigingsdatum)}</span>
      </div>
    </li>
  );
};

export default PersonaliaItem;
